/** Pure scoring rules (unit tested). */
import { TileType } from '../data/maze-data'
import {
  DOT_POINTS,
  POWER_PELLET_POINTS,
  GHOST_POINTS_BASE,
  JELLY_PER_CAPTURE,
} from '../constants/game-config'

export const CAPTURE_JELLY = JELLY_PER_CAPTURE

/** Points for collecting a pellet tile. */
export function pelletPoints(tile: TileType): number {
  if (tile === TileType.Dot) return DOT_POINTS
  if (tile === TileType.PowerPellet) return POWER_PELLET_POINTS
  return 0
}

/** Capture score doubles per consecutive capture within one power window: 200,400,800,1600. */
export function captureScore(streak: number): number {
  const s = Math.max(1, streak)
  return GHOST_POINTS_BASE * Math.pow(2, s - 1)
}
